import { render, staticRenderFns } from "./buyerWithdrawAudit.vue?vue&type=template&id=0966fd40&"
import script from "./buyerWithdrawAudit.vue?vue&type=script&lang=js&"
export * from "./buyerWithdrawAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports